import React, { Component } from 'react';
import { Row, Col } from 'reactstrap';
import DeviceCarousel from '../device-carousel/DeviceCarousel';
import EirColourSelector from '../colour-selector/EirColourSelector';
import DeviceNotification from '../eir-device-notification/DeviceNotification';
import FAQ from '../faq/FAQ';
import DeviceDetailsPrice from '../device-details-price/DeviceDetailsPrice';
import CartSummary from '../cart-summary/CartSummary';
import UpgradeStatus from '../upgrade/UpgradeStatus';
import OutOfStockEmail from '../out-of-stock-email/OutOfStockEmail';
import Constants from '../../Constants';
import PubSub from 'pubsub-js';
import Loading from '../shared/Loading';
import Routing from '../../utils/Routing';
import { Button } from '@material-ui/core';
import axios from 'axios';

class EirDeviceDetails extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedVariant: null,
            prices: this.props.device.details.prices,
            pricesValid: true,
            mobileDetails: this.props.device.details.prices.filter(
                priceList => priceList.mobileOrderType === 'NEW'
            ),
        };
    }

    getInitialSelectedVariant() {
        let variant = null;
        if (Routing.urlHasQuery()) {
            variant = this.props.device.variants.filter(
                variant =>
                    variant.name.toLowerCase() == Routing.getQueryParameter('variant').toLowerCase()
            )[0];
        }

        if (!variant) {
            variant = this.props.device.variants.filter(variant => variant.inStock)[0];
        }

        if (!variant) {
            variant = this.props.device.variants[0];
        }

        return variant;
    }

    componentWillUnmount() {
        if (this.priceChangeToken) {
            PubSub.unsubscribe(this.priceChangeToken);
        }
        if (this.priceInvalidToken) {
            PubSub.unsubscribe(this.priceInvalidToken);
        }
    }

    componentDidMount() {
        this.priceInvalidToken = PubSub.subscribe(
            Constants.eventKeys.deviceDetailsPriceInvalid,
            this.handleUpdatedPrices
        );
        this.priceChangeToken = PubSub.subscribe(
            Constants.eventKeys.deviceDetailsPriceChanged,
            this.handleUpdatedPrices
        );
    }

    setSelectedVariant = selectedVariant => {
        this.setState({ selectedVariant: selectedVariant });
        this.setURL(selectedVariant);
    };

    setURL(variant) {
        let variantURL = Routing.getUrlWithoutQuery(window.location.href);
        variantURL = Routing.addQueryParameter('variant', variant.name.toLowerCase(), variantURL);
        history.replaceState({ id: 'query page' }, 'Device Details', variantURL);
    }

    getCarouselImages() {
        let selectedVariant = this.getSelectedVariant();

        if (
            selectedVariant &&
            selectedVariant.carouselImages &&
            selectedVariant.carouselImages.length
        ) {
            return selectedVariant.carouselImages;
        } else {
            for (let i = 0; i < this.props.device.variants.length; i++) {
                if (
                    this.props.device.variants[i].carouselImages &&
                    this.props.device.variants[i].carouselImages.length > 0
                ) {
                    return this.props.device.variants[i].carouselImages;
                }
            }
        }

        // unable to find any carousel images. look for the main image instead
        if (selectedVariant && selectedVariant.image && selectedVariant.image.path) {
            return [selectedVariant.image.path];
        } else {
            for (let i = 0; i < this.props.device.variants.length; i++) {
                if (
                    this.props.device.variants[i].image &&
                    this.props.device.variants[i].image.path
                ) {
                    return [this.props.device.variants[i].image.path];
                }
            }
        }

        return [];
    }

    convertFeaturesAndSpecificationsToFaq() {
        var faqs = [
            {
                question: 'KEY FEATURES',
                answer: this.renderFeatures(),
            },
            {
                question: 'DETAILED SPECIFICATIONS',
                answer: this.renderSpecifications(),
            },
        ];

        return faqs;
    }

    renderFeatures() {
        let features = [];

        this.props.device.details.features.forEach(feature => {
            features.push(<li>{feature}</li>);
        });

        return <ul>{features}</ul>;
    }

    handleUpdatedPrices = (event, prices) => {
        if (prices) {
            this.setState({
                prices: prices,
                pricesValid: true,
            });
        } else {
            this.setState({
                pricesValid: false,
            });
        }
    };

    renderPrices(selectedVariant) {
        if (selectedVariant.inStock) {
            return this.state.prices.map((price, index) => {
                price.variantSku = selectedVariant.sku;
                price.deviceId = this.props.device.id;
                return (
                    <DeviceDetailsPrice priceTypes={this.props.priceTypes} {...price} key={index} />
                );
            });
        } else {
            let outOfStockFormProps = {
                ...this.props.outOfStockForm,
                ...{ selectedVariant: selectedVariant },
                ...{ device: this.props.device },
            };

            return (
                <div className='out-of-stock-container'>
                    <OutOfStockEmail {...outOfStockFormProps} />
                </div>
            );
        }
    }

    renderSpecifications() {
        let specs = [];

        this.props.device.details.specifications.forEach(spec => {
            if (spec.type == 'string') {
                specs.push(
                    <li>
                        {spec.name} : {spec.value}
                    </li>
                );
            } else if (spec.type == 'boolean' && spec.value == 'yes') {
                specs.push(<li>{spec.name}</li>);
            }
        });

        return <ul>{specs}</ul>;
    }

    getSelectedVariant() {
        return this.state.selectedVariant || this.getInitialSelectedVariant();
    }
    clearProspect() {
        localStorage.removeItem('prospectUuid');
        localStorage.removeItem('offerId');
        localStorage.removeItem('plan-name');
        localStorage.removeItem('handset-name');
        localStorage.removeItem('prepayHandsetId');
        localStorage.removeItem('IONOrderReference');
        localStorage.removeItem('planToggle');
    }
    render() {
        var url = window.location.href;
        var prepay = url.match(/prepay/);
        return (
            <React.Fragment>
                <Row className='mb-5'>
                    <Col lg='6' className='d-flex flex-column'>
                        <div className='order-1'>
                            <h6 className='text-uppercase text-base-gray mb-2'>
                                {this.props.device.manufacturer}
                            </h6>
                            <h1 className='text-black mb-4'>{this.props.device.model}</h1>
                        </div>

                        <div className='order-2 d-lg-none mb-5'>
                            <DeviceCarousel images={this.getCarouselImages()}>
                                <DeviceNotification
                                    device={this.props.device}
                                    selectedVariant={this.getSelectedVariant()}
                                />
                            </DeviceCarousel>
                        </div>

                        <div className='order-3 mb-5'>
                            <div className='d-flex justify-content-between'>
                                <h6 className='text-left text-uppercase text-base-gray mb-md-2'>
                                    COLOUR
                                </h6>
                                <h6 className='text-right text-uppercase text-danger mb-md-2'>
                                    {this.getSelectedVariant().stockStatus}
                                </h6>
                            </div>
                            <EirColourSelector
                                colourOptions={this.props.device.variants}
                                selectedColour={this.getSelectedVariant()}
                                large={true}
                                onColourSelected={this.setSelectedVariant}
                            />
                        </div>

                        <div className='order-4 order-lg-2 mb-4'>
                            <p>{this.props.device.details.description}</p>
                        </div>

                        <div className='order-5'>
                            <CartSummary {...this.props.cartSummary} className='mb-4' />

                            {this.state.pricesValid && (
                                <div className='price-container'>
                                    {prepay != 'prepay' ? (
                                        <div>
                                            <UpgradeStatus
                                                {...this.props.upgradeChecker}
                                                className='mb-3'
                                            />
                                            <div className='d-flex mb-2 price-list-container'>
                                                {this.renderPrices(this.getSelectedVariant())}
                                            </div>
                                        </div>
                                    ) : (
                                        ''
                                    )}
                                    {prepay == 'prepay' && this.getSelectedVariant().inStock ? (
                                        <div>
                                            <form action='/store/orders/create' method='post'>
                                                <input
                                                    type='hidden'
                                                    name='customerType'
                                                    value='NEW'
                                                />
                                                <input
                                                    type='hidden'
                                                    name='mobileOrderType'
                                                    value={
                                                        this.state.mobileDetails[0].mobileOrderType
                                                    }
                                                />
                                                <input
                                                    type='hidden'
                                                    name='variantSku'
                                                    value={this.getSelectedVariant().sku}
                                                />
                                                <input
                                                    type='hidden'
                                                    name='deviceId'
                                                    value={this.props.device.id}
                                                />
                                                <input
                                                    type='hidden'
                                                    name='mobilePlanId'
                                                    value={this.state.mobileDetails[0].mobilePlanId}
                                                />
                                                <Button
                                                    className='buy-button'
                                                    type='submit'
                                                    onClick={this.clearProspect()}>
                                                    Buy Now
                                                </Button>
                                            </form>
                                        </div>
                                    ) : (
                                        ''
                                    )}

                                    {this.props.device.availability.availableDate && (
                                        <h6 className='mt-4'>
                                            {this.props.preOrderMessage}&nbsp;
                                            <span className='me-2'>
                                                {new Date(
                                                    this.props.device.availability.availableDate
                                                ).toLocaleString('en-us', { day: '2-digit' }) +
                                                    '/' +
                                                    new Date(
                                                        this.props.device.availability.availableDate
                                                    ).toLocaleString('en-us', {
                                                        month: '2-digit',
                                                    }) +
                                                    '/' +
                                                    new Date(
                                                        this.props.device.availability.availableDate
                                                    ).toLocaleString('en-us', { year: 'numeric' })}
                                            </span>
                                        </h6>
                                    )}
                                </div>
                            )}

                            {this.state.pricesValid == false && <Loading className='mt-6' />}
                        </div>
                    </Col>

                    <Col lg='6' className='d-none d-lg-flex align-items-stretch flex-column'>
                        <DeviceCarousel images={this.getCarouselImages()}>
                            <DeviceNotification
                                device={this.props.device}
                                selectedVariant={this.getSelectedVariant()}
                            />
                        </DeviceCarousel>
                    </Col>
                </Row>

                <FAQ Title='' faqs={this.convertFeaturesAndSpecificationsToFaq()} />
            </React.Fragment>
        );
    }
}

export default EirDeviceDetails;
